// extracted by mini-css-extract-plugin
module.exports = {"page":"AboutPage_page__2Dvod","description":"AboutPage_description__3y-zD","information":"AboutPage_information__2_jAm"};